/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Loading_Sync_DescriptionInputs */



/**
* | output |
* | --- |
* | "Fetching files from your cloud storage. This may take a moment." |
*
* @param {Spaces_Wizard_Loading_Sync_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_loading_sync_description = /** @type {((inputs?: Spaces_Wizard_Loading_Sync_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Loading_Sync_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien werden aus deinem Cloud-Speicher abgerufen. Dies kann einen Moment dauern.")
	return /** @type {LocalizedString} */ ("Fetching files from your cloud storage. This may take a moment.")
});